import { ScgpExportOrderStatus } from "@saleor/graphql";
import { mapCodeToMessageIplant } from "@saleor/utils/errorsIplan";
import errorsSapItem from "@saleor/utils/errorsSapItem.json";

export function mapVariantToColor(
  variant: string | ScgpExportOrderStatus,
  isBgrColor: boolean
) {
  switch (variant) {
    case ScgpExportOrderStatus.RECEIVED_ORDER:
      return {
        color: "#A3AED0",
        ...(isBgrColor && { backgroundColor: "#A3AED0" }),
        ...(variant && { borderRadius: "1rem" })
      };
    case ScgpExportOrderStatus.CREDIT_CASH_ISSUE:
      return {
        color: "#FFC107",
        ...(isBgrColor && { backgroundColor: "#FFC107" }),
        ...(variant && { borderRadius: "1rem" })
      };
    case ScgpExportOrderStatus.PARTIAL_COMMITTED_ORDER:
      return {
        color: "#3860BE",
        ...(isBgrColor && { backgroundColor: "#3860BE" }),
        ...(variant && { borderRadius: "1rem" })
      };
    case ScgpExportOrderStatus.READY_FOR_DELIVERY:
      return {
        color: "#007BFF",
        ...(isBgrColor && { backgroundColor: "#007BFF" }),
        ...(variant && { borderRadius: "1rem" })
      };
    case ScgpExportOrderStatus.PARTIAL_DELIVERY:
      return {
        color: "#009FB8",
        ...(isBgrColor && { backgroundColor: "#009FB8" }),
        ...(variant && { borderRadius: "1rem" })
      };
    case ScgpExportOrderStatus.COMPLETED_DELIVERY:
      return {
        color: "#6CC04A",
        ...(isBgrColor && { backgroundColor: "#6CC04A" }),
        ...(variant && { borderRadius: "1rem" })
      };
    case ScgpExportOrderStatus.CANCELLED:
      return {
        color: "#E41B17",
        ...(isBgrColor && { backgroundColor: "#E41B17" }),
        ...(variant && { borderRadius: "1rem" })
      };
    case ScgpExportOrderStatus.COMPLETED_ORDER:
      return {
        color: "#1E7D34",
        ...(isBgrColor && { backgroundColor: "#1E7D34" }),
        ...(variant && { borderRadius: "1rem" })
      };
    default:
      break;
  }
}

export const showNotifyMessage = (
  notify,
  errors = [],
  sapOrderMessages = [],
  sapItemMessages = [],
  iPlanMessages = [],
  warningMessages = []
) => {
  let orderErrors = "";
  let orderWarning = "";

  if (errors?.length) {
    errors.forEach(({ message }) => {
      orderErrors += `${message} \n`;
    });
  }
  if (sapOrderMessages?.length) {
    sapOrderMessages.forEach(({ number, soNo, message }) => {
      orderErrors += `SAP - ${soNo} - ${number} - ${message} \n`;
    });
  }
  if (sapItemMessages?.length) {
    sapItemMessages.forEach(({ itemNo, itemStatus }) => {
      orderErrors += `SAP - ${itemNo} - ${itemStatus} - ${errorsSapItem[
        itemStatus
      ]?.MESSAGE || ""} \n`;
    });
  }
  if (iPlanMessages?.length) {
    iPlanMessages.forEach(item => {
      const messageOptional = item.message;
      const message = mapCodeToMessageIplant(
        item.firstCode,
        item.secondCode,
        messageOptional
      );
      orderErrors += `${message} \n`;
    });
  }

  if (warningMessages?.length) {
    warningMessages.forEach(({ order, message }) => {
      orderWarning += `${order} - ${message}\n`;
    });
  }

  if (orderErrors) {
    notify({
      status: "error",
      apiMessage: orderErrors
    });
  }

  if (orderWarning) {
    notify({
      status: "warning",
      title: "Warning",
      apiMessage: orderWarning,
      autohide: null
    });
  }
};
